import { useContext } from "react";
import { AppContext } from "./Context";

function Search() {
  const srch = useContext(AppContext);

  return (
    <div>
      
      

      {/* Show results only if srch has items */}
      {Array.isArray(srch) && srch.length > 0 && srch.map((item, idx) => (
        <div key={idx}>
          <h3>{item.title}</h3>
          <span>{item.summary}</span>
          <a href={item.url} target="_blank" rel="noreferrer">
            <button className="more">More</button>
          </a>
          <hr />
        </div>
      ))}
    </div>
  );
}

export default Search;